<template>
  <span>
    <select v-if="displayType === 'form'" name="" class="form-control"
            v-bind:value="modelValue" v-on:change="onChange($event.target.value)"
            :disabled="inputDisabled">
      <slot></slot>
      <option v-if="allowNull" value=""></option>
      <option value="0" :selected="0 === defaultConference">Independent</option>
      <option v-for="conference in conferenceList" :value="conference.orgId"
              :selected="conference.orgId === defaultConference">
      {{ conference.nameOfficial }}
    </option>
    </select>
    <span v-if="displayType === 'label'">{{ conferenceLabel }}</span>
  </span>
</template>

<script>
import CommonDataService from '../endpoints/CommonDataService'

export default {
    emits: ['update:modelValue','change'],
  name: 'conference-input',

  props: {
    modelValue: { default: null },
    displayType: String,
    inputDisabled: Boolean,
    allowNull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      conferenceList: []
    }
  },
  computed: {
    defaultConference () {
      return this.modelValue
    },
    conferenceLabel: function () {
      if (this.conferenceList && this.conferenceList.length > 0) {
        let conference = this.conferenceList.find((el) => el.orgId === this.modelValue)
        if (conference) return conference.nameOfficial
      }

      return ''
    }
  },
  methods: {
    loadConferenceList: function () {
      let self = this
      if (sessionStorage.conferenceList && sessionStorage.conferenceList.length > 0) {
        self.conferenceList = JSON.parse(sessionStorage.conferenceList)
        return
      }

      CommonDataService.loadConferenceList()
        .then(response => {
          self.conferenceList = response.data
          sessionStorage.conferenceList = JSON.stringify(self.conferenceList)
        })
        .catch(error => {
          self.error = error.message
        })
    },
    onChange (value) {
      this.$emit('update:modelValue', value ? Number(value) : value)
        this.$emit('change', value ? Number(value) : value)
    }
  },
  created () {
    this.loadConferenceList()
  }
}
</script>
